import BasicTabs from "shared/ui/Tabs";
import { Box } from "@mui/system";
import { emailDistributionTabData } from "./constants";

const EmailDistributionMain = () => {
  return (
    <Box>
      <BasicTabs tabsData={emailDistributionTabData} />
    </Box>
  );
};

export default EmailDistributionMain;
